import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // 左侧菜单栏数据
        menuItems: "",
        // 连接服务器
        urlPort: "http://106.14.19.122:7002",
        //urlPort: "http://127.0.0.1:7002",
        // 不断从交易所上获取数据
        k_line_data: "",
        // 存储订单执行的字典
        function_type_index: {
            0:'市价',
            1:'限价追单',
            2:'脉冲追单V1.0',
        }
    },
    mutations: {
        setMenus(state, items) {
            state.menuItems = [...items]
        },
        init_k_line_data: async function(state, mode) {
            let data = await axios.get(
                state.urlPort + "/load_echarts_data",
                { params: { mode: "data_kline", which_web_need: mode } }
            )
            data = data["data"]
            if (mode == "full_data") {
                state.k_line_data = data
            } 
            else {
                length = state.k_line_data.length - 1
                if (data[0] == state.k_line_data[length][0]) {
                    state.k_line_data[length] = data
                }
                else {
                    state.k_line_data.push(data)
                }
            }
        },
    }
})

export default store